// extracted by mini-css-extract-plugin
export default {"studentDetailReportDialog":"studentDetailReportDialog-eK299","modalBody":"modalBody-yWxz0","modalContent":"modalContent-neXho","blueHeader":"blueHeader-Hs0F2"};